import { connect } from 'react-redux';
import jwtDecode from 'jwt-decode';

import {
  actionRefreshTokenSuccess,
  actionRefreshTokenFailed,
  actionGetMyPermission,
} from 'store/actions';
import actionGetSetting from 'store/setting/actions';
import { GET_ME, GET_PROFILE_EXTRANET } from 'store/auth/profile/actionTypes';
import { LOGIN_TYPE, storageKey } from 'constants/index';

import App from './App';

const mapStateToProps = (state) => ({
  me: state.Profile.me,

  setting: state.Setting.setting,

  isLoggedIn: state.Login.isLoggedIn,

  isLoadingGetMyPermission: state.Administrator.isLoadingGetMyPermission,
  myPermission: state.Administrator.myPermission,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetMe: (payload) => {
    const token = localStorage.getItem(storageKey.AUTHENTICATE_TOKEN);
    let isIntranet = true;

    if (token) {
      try {
        const decoded = jwtDecode(token);
        if (decoded && typeof decoded.isIntranet === 'boolean') {
          isIntranet = decoded.isIntranet;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to decode token in App.container:', e);
      }
    } else {
      const loginType = localStorage.getItem(storageKey.LOGIN_TYPE);
      if (loginType === LOGIN_TYPE.EXTRANET) {
        isIntranet = false;
      }
    }

    if (!isIntranet) {
      dispatch({
        type: GET_PROFILE_EXTRANET,
        payload,
      });
      return;
    }

    dispatch({
      type: GET_ME,
      payload,
    });
  },

  actionGetSetting: (payload) => dispatch(actionGetSetting(payload)),

  actionRefreshTokenSuccess: (payload) => dispatch(actionRefreshTokenSuccess(payload)),
  actionRefreshTokenFailed: () => dispatch(actionRefreshTokenFailed()),

  actionGetMyPermission: (payload) => dispatch(actionGetMyPermission(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
